import { surfaceDisplayStatus, type SurfaceEntry } from '@/lib/sync/document-surfaces';

export type OrbStatus = 'idle' | 'generating' | 'failed' | 'recording';

export function deriveOrbStatus(entries: readonly SurfaceEntry[], isCapturing: boolean): OrbStatus {
  if (isCapturing) return 'recording';
  const statuses = entries.map(surfaceDisplayStatus);
  if (statuses.includes('failed')) return 'failed';
  if (statuses.includes('generating') || statuses.includes('regenerating')) return 'generating';
  return 'idle';
}
